export enum LogEventsEnum {
  app_update = 'app_update',
  lots_list_view = 'lots_list_view',
  lots_detail_view = 'lots_detail_view',
  lots_create_view = 'lots_create_view',
  trades_list_view = 'trades_list_view',
  negotiations_list_view = 'negotiations_list_view',
  chats_list_view = 'chats_list_view',
  auth_login = 'auth_login',
  auth_forgot_password = 'auth_forgot_password',
  auth_forgot_verify_otp = 'auth_forgot_verify_otp',
  auth_forgot_new_password = 'auth_forgot_new_password',
  contracts_list_view = 'contracts_list_view',
  contracts_detail_view = 'contracts_detail_view',
  settings_view = 'settings_view',
  settings_tap_sign_out = 'settings_tap_sign_out',
  lots_summary_view = 'lots_summary_view',
  lots_summary_submit_tap = 'lots_summary_submit_tap',
  negotiations_detail_view = 'negotiations_detail_view',
  negotiations_detail_revoke_tap = 'negotiations_detail_revoke_tap',
  negotiations_detail_decline_tap = 'negotiations_detail_decline_tap',
  negotiations_detail_counter_tap = 'negotiations_detail_counter_tap',
  negotiations_detail_accept_tap = 'negotiations_detail_accept_tap',
  negotiations_form_view = 'negotiations_form_view',
  negotiations_form_submit_tap = 'negotiations_form_submit_tap',
  lots_detail_withdraw_tap = 'lots_detail_withdraw_tap',
  lots_detail_counter_tap = 'lots_detail_counter_tap',
  lots_detail_accept_tap = 'lots_detail_accept',
  lots_detail_repost_tap = 'lots_detail_repost_tap',
  lot_edit = 'lot_edit',
  commodity_selection_view = 'commodity_selection_view',
  user_update = 'user_update',
}
